import React, { useEffect, useState } from 'react'
import classes from './signup.module.css'
import loginImage from '../../assets/images/Login.jpg'
import logo from '../../assets/images/new-logo.png'
import { Button, ButtonIcon } from '../../components/Button/Button'
import { ReactComponent as ArrowRight } from '../../assets/icons/arrow-right.svg'
import { ValidatedLoginInput } from '../../components/Form/Inputs/Inputs'
import { Link } from 'react-router-dom'
import { getParentRoute } from '../../util/functions'
import { Formik } from 'formik'
import { BusinessSignUpSchema } from '../../util/formSchemas'
import { useDispatch, useSelector } from 'react-redux'
import { signUp } from '../../api/authApi'
import useAuthForm from '../../hooks/useAuthForm'
import { UserTypes } from '../../util/constants'
import { startWizard } from '../Wizard/wizardLogic'
import { cartSelectors } from '../Cart/cartSlice'

const BusinessSignUp = ({ location, history }) => {
    const path = getParentRoute(location.pathname)
    const itemDetails = useSelector(cartSelectors.cartItemDetails)
    const dispatch = useDispatch()
    const isCartAvailable = Object.keys(itemDetails)?.length > 0

    useAuthForm(
        () => history.push(isCartAvailable ? '/app/cart' : startWizard()),
        true
    )

    const submitForm = values => {
        //Show loader
        dispatch(signUp(values, UserTypes.Business))
    }

    return (
        <div className={classes.container}>
            <Formik
                initialValues={{
                    firstname: '',
                    lastname: '',
                    email: '',
                    password: '',
                    confirmPassword: '',
                    jobTitle: '',
                    number: '',
                    domainName: '',
                    phonenumber: '',
                }}
                onSubmit={submitForm}
                validationSchema={BusinessSignUpSchema}
            >
                {({ handleSubmit }) => (
                    <div className={classes.form}>
                        <img
                            src={logo}
                            alt="Logo"
                            className={classes.formLogo}
                            onClick={() => history.push('/')}
                        />
                        <h1 className={classes.formHeader}>
                            Sign up to start learning (Business User)
                        </h1>
                        <div className={classes.formInputs}>
                            <div className={classes.formRow}>
                                <ValidatedLoginInput
                                    placeholder={'First Name'}
                                    name={'firstname'}
                                />
                                <ValidatedLoginInput
                                    placeholder={'Last Name'}
                                    name={'lastname'}
                                />
                            </div>
                            <ValidatedLoginInput
                                placeholder={'Business Email Address'}
                                name={'email'}
                            />
                            <ValidatedLoginInput
                                placeholder={'Phone Number'}
                                name={'phonenumber'}
                            />
                            <div>
                                <ValidatedLoginInput
                                    placeholder={'Business name'}
                                    name={'domainName'}
                                />
                                <small className={classes.inputDescription}>
                                    Your beneficiaries will login at
                                    app/beneficiary/business-name/sign-in
                                </small>
                            </div>
                            <ValidatedLoginInput
                                placeholder={'Job Title'}
                                name={'jobTitle'}
                            />
                            <ValidatedLoginInput
                                placeholder={'Your Password'}
                                name={'password'}
                                type={'password'}
                            />
                            <ValidatedLoginInput
                                placeholder={'Confirm Password'}
                                name={'confirmPassword'}
                                type={'password'}
                            />
                        </div>
                        <Button
                            className={classes.formButton}
                            bold={false}
                            onClick={handleSubmit}
                        >
                            Get Started
                            <ButtonIcon icon={<ArrowRight />} />
                        </Button>
                        <span className={classes.formSplitLine} />
                        <p className={classes.formSignInText}>
                            Already have an account?{' '}
                            <Link
                                to={`/app/auth/sign-in`}
                                className={classes.formSignInTextOrange}
                            >
                                Sign In
                            </Link>{' '}
                        </p>
                        <p className={classes.formSignInText}>
                            Are you an individual user?{' '}
                            <Link
                                to={`/app/auth/sign-up`}
                                className={classes.formSignInTextOrange}
                            >
                                Sign Up Here
                            </Link>
                        </p>
                    </div>
                )}
            </Formik>
            <img
                src={loginImage}
                alt="Login Page Background"
                className={classes.displayImage}
            />
        </div>
    )
}

export default BusinessSignUp
